import { combineReducers } from 'redux';
import * as ActionTypes from './costEstimate.actionTypes';
import keys from 'lodash/keys';
import merge from 'lodash/merge';
import omit from 'lodash/omit';

const allIds = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.CREATE_COSTESTIMATE_SUCCESS:
      return [...state, action.response.result];
    case ActionTypes.DELETE_COSTESTIMATE_SUCCESS:
    case ActionTypes.DELETE_COSTESTIMATE_FAILURE: {
      const deletedIndex = state.indexOf(action.payload.id);
      if (deletedIndex === -1) {
        return state;
      }
      return [
        ...state.slice(0, deletedIndex),
        ...state.slice(deletedIndex + 1),
      ];
    }
    case ActionTypes.READ_COSTESTIMATE_SUCCESS: {
      const newEntryIndex = state.indexOf(action.response.result);
      if (newEntryIndex > -1) {
        return state;
      }
      return [...state, ...action.response.result];
    }
    default:
      return state;
  }
};

const byType = (state = {}, action) => {
  if (
    action.response &&
    action.response.entities &&
    action.response.entities.costEstimate
  ) {
    if (action.response.method && action.response.method === 'DELETE') {
      return omit(state, keys(action.response.entities.costEstimate));
    }
    return merge({}, state, action.response.entities.costEstimate);
  }
  return state;
};
const reducer = combineReducers({
  allIds,
  byType,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/costEstimate/costEstimate.reducer.js